// extracted by mini-css-extract-plugin
export default {"icon":"_-_-record-it-components-src-button-DropdownButton-__icon"};